module.exports = __webpack_public_path__ + "static/media/ST.c84fded2.png";